(function TripSummaryReplaceCruiseDayImage($, Adzuki)
{
	'use strict';

	const component = {
		// MEDIA-334: the redesigned picker, registered here so Change Photo always gets
		// it rather than whichever adzuki-select-files its host app resolves to
		components: (Adzuki.MediaHubPicker && Adzuki.MediaHubPicker.selectFiles)
			? { 'adzuki-select-files': Adzuki.MediaHubPicker.selectFiles() }
			: {},
		emits: [
			'component-event',
		],
		inject: [
			'getFaIconStyle',
		],
		props: {
			selectedDay: {
				type    : Object,
				required: true,
			},
		},
		data() {
			return {
				baseUri               : Adzuki.base_uri,
				loadingMediaItems     : false,
				locationResults       : [],
				selectedLocationImage : null,
				locationSearchDisabled: false,
				fetchingLocationImages: false,
				media                 : [],
				replacingImage        : false,
				section               : 'ts-component-image',
				sectionInfo           : {},
			};
		},
		methods: {
			closeModal() {
				this.$emit('component-event', { type: 'close-modal' });
			},
			async getMedia() {
				const url = `${this.baseUri + '/Media/getMediaItems/' + this.section}`;

				this.loadingMediaItems = true;

				try {
					const response = await Adzuki.Ajax.get(url);

					if (!response) {
						return Adzuki.StatusMessage('error', 'Error fetching Media items: No response from server');
					}

					// Media Hub reads need the terms accepted (MEDIA-288)
					if (response.code === 'tos_required') {
						this.media = [];

						return Adzuki.StatusMessage('error', 'Please accept the Maxx Media Terms and Conditions to use your media here. Open Maxx Media to review and accept them.');
					}

					this.media = response;

					Adzuki.MediaUrls.resolveAll(this.media).catch((error) => {
						console.error('Error loading media URLs:', error);
					});
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error fetching Media items: ${error.message}`);
				} finally {
					this.loadingMediaItems = false;
				}
			},
			async getSectionInfo() {
				const url = `${this.baseUri + '/MediaSection/getSection/' + this.section}`;

				try {
					const response = await Adzuki.Ajax.get(url);

					if (!response) {
						return Adzuki.StatusMessage('error', 'Error fetching Media Sections: No response from server');
					}

					this.sectionInfo = response;
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error fetching Media items: ${error.message}`);
				}
			},
			async replaceImage() {
				if (!this.selectedLocationImage) {
					return Adzuki.StatusMessage('error', 'Please select an image');
				}

				this.replacingImage = true;

				try {
					const url      = '/TripSummaryPictureLibrary/saveLocationImage/' + this.selectedLocationImage;
					const response = await Adzuki.Ajax.get(url);

					if (response.error) {
						return Adzuki.StatusMessage('error', `Error replacing cruise day image: ${response.error}`);
					}

					const image     = response.image;
					const eventData = {
						type : 'selected-image',
						image: image,
					};

					this.selectedLocationImage = null;
					this.$emit('component-event', eventData);
					this.closeModal();
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error replacing cruise day image: ${error.message}`);
				} finally {
					this.replacingImage = false;
				}
			},
			resetLocationSearch() {
				this.locationSearchDisabled = false;
				this.locationResults        = [];
				this.selectedLocationImage  = null;

				this.$refs.locationSearchInput.value = '';
			},
			selectLocationImage(image) {
				if (this.selectedLocationImage === image) {
					this.selectedLocationImage = null;
				} else {
					this.selectedLocationImage = image;
				}
			},
			async selectMedia(media) {
				if (!media.media_id) {
					this.closeModal();

					return Adzuki.StatusMessage('error', 'No media found, could not replace cruise day image');
				}

				const mediaIds = [];

				// only one image allowed to replace cruise day image
				if (Array.isArray(media.media_id)) {
					mediaIds.push(media.media_id[0]);
				} else {
					mediaIds.push(media.media_id);
				}

				try {
					const response = await Adzuki.Ajax.post('/Media/getMediaItemsById', {
						media_ids: JSON.stringify(mediaIds)
					});

					if (response.status === 'error') {
						this.closeModal();

						return Adzuki.StatusMessage('error', `Error getting media items: ${response.message}`);
					}

					const mediaItems = response;

					if (mediaItems.length === 0) {
						return Adzuki.StatusMessage('error', 'No media items selected, could not replace cruise day image');
					}

					// there should only be one media item
					const mediaItem = mediaItems[0];

					// copy the file into the picture folder and use those paths: a Maxx Media path can
					// be missing (S3-only), or name a local file that is no longer there, and an S3-only
					// video's thumbnail is a bucket url (MEDIA-313). The copy reads the local file first.
					const saved = await Adzuki.Ajax.get('/TripSummaryPictureLibrary/saveMediaHubImage/' + mediaItem.id);

					if (!saved || saved.error || !saved.image) {
						this.closeModal();

						return Adzuki.StatusMessage('error', `Error replacing cruise day image: ${saved && saved.error ? saved.error : 'No response from server'}`);
					}

					const cruiseImage = saved.image;
					const cruiseVideo = saved.video || null;

					const eventData   = {
						type : 'selected-image',
						image: cruiseImage,
						video: cruiseVideo,
					};

					this.$emit('component-event', eventData);

					this.closeModal();
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error getting media items: ${error.message}`);
				}
			},
		},
		async mounted() {
			// location typeahead
			Adzuki.Typeahead(
				this.$refs.locationSearchInput,
				'/Searches/googleAutocomplete/',
				async (item, $self, typeahead) => {
					this.fetchingLocationImages = true;

					try {
						const url      = '/Searches/googlePlace/' + item.id + '/1';
						const response = await Adzuki.Ajax.get(url);

						if (response.error) {
							return Adzuki.StatusMessage('error', `Error getting location details: ${response.error}`);
						}

						if (!response || response.length === 0) {
							return Adzuki.StatusMessage('error', 'No images found');
						}

						this.locationResults        = response;
						this.locationSearchDisabled = true;
					} catch (error) {
						return Adzuki.StatusMessage('error', `Error getting place details: ${error.message}`);
					} finally {
						this.fetchingLocationImages = false;
					}
				},
				function template(item) {
					return item.name;
				}
			);

			// load maxx media items
			await this.getMedia();
			await this.getSectionInfo();
		},
		template: '#ts-replace-cruise-day-image',
	};

	Adzuki.VueComponents.TripSummaryReplaceCruiseDayImage = component;
}(jQuery, window.Adzuki || {}));
